import React from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import {
  BackgroundImage,
  DesktopImage,
  MobileImage,
  DescriptionWrapper,
} from '../../../FivePound/components/CustomMealPlan/CustomMealPlan.styles'
import background from '../../../../../../../../public/assets/product/startrbackground.webp'
import Trans from 'next-translate/Trans'
import Link from 'next/link'
import { Spacer } from '../../../Startr/components/FeedGreat/FeedGreat.styles'
import { StartrMixinRoot, ContentWrapper } from './StartrMixin.styles'

export const StartrMixin: React.FC = () => {
  const { t } = useTranslation('products')

  return (
    <StartrMixinRoot>
      <BackgroundImage>
        <DesktopImage>
          <Image src={background} alt={t('products:treats.startr.imageAlt')} />
        </DesktopImage>
        <MobileImage css={{height: '477px', maxWidth: '374px'}}>
          <Image layout='fill' objectFit='cover' objectPosition='11% 0%' src={background} alt={t('products:treats.startr.imageAlt')} />
        </MobileImage>
        <ContentWrapper>
          <Text
            as="h2"
            align="left"
            size="h1"
            weight="semiBold"
            color="accent-white"
          >
            {t('products:treats.startr.title')}
          </Text>
          <Link href="/products/treats">
            <Button>{t('products:treats.startr.cta')}</Button>
          </Link>
        </ContentWrapper>
      </BackgroundImage>
      <DescriptionWrapper css={{ gap: '$2', paddingBottom: '$1' }}>
        <Text size="h1" color="accent-white" align="center" weight="semiBold">
          <Trans
            i18nKey={'products:treats.startr.title'}
            components={{ br: <br /> }}
          />
        </Text>
        <Link href="/products/treats">
          <Button>{t('products:treats.startr.cta')}</Button>
        </Link>
        <Spacer />
      </DescriptionWrapper>
    </StartrMixinRoot>
  )
}
